module.exports = __webpack_public_path__ + "img/logo.1f768a6d.png";